import { DropdownButtonItem } from "@shared/primitive-components"
import { Status } from "@shared/types"
import { TEST_IDS } from "./components"

export const MatrixTSPId = `5bf237dc-1b1f-11ee-be56-0242ac120002`

export const FLEET_LIST_PAGE_DTI = `fleet_list_root`
export const EDIT_COVER_DATES_BUTTON_DATA_TEST_ID = `editCoverDatesButton`
export const ADD_VEHICLES_DTI = `add_vehicles_button`

export const DATA_TEST_IDS = {
  root: FLEET_LIST_PAGE_DTI,
  loading: TEST_IDS.LOADING,
  buttonLeft: EDIT_COVER_DATES_BUTTON_DATA_TEST_ID,
  search: TEST_IDS.SEARCH,
  button: ADD_VEHICLES_DTI,
}

export const FILTER_ITEMS: Array<DropdownButtonItem<Status | null>> = [
  {
    text: `Off cover`,
    value: `off_cover`,
    dataTestId: TEST_IDS.OFFCOVER,
  },
  {
    text: `Scheduled`,
    value: `scheduled`,
    dataTestId: TEST_IDS.SCHEDULED,
  },
  {
    text: `All`,
    value: null,
    dataTestId: TEST_IDS.ALL,
  },
]
